<div class="container">
  <div class="modal-header" *ngIf="!isLoading">
    <div class="device-header">
      <span>
        <i class="mdi mdi-file-document-edit-outline file-icon"></i>
        <span class="header">Edit device</span>
      </span>
      <i class="mdi mdi-close close-icon" mat-dialog-close></i>
    </div>
  </div>
  <div class="loader-content" *ngIf="isLoading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Loading...</div>
    </div>
  </div>

  <form novalidate #deviceForm="ngForm">
    <div *ngIf="!isLoading">
      <div class="setup">
        <div class="section-container">
          <div class="section-data">
            <div class="name-field">
              <div class="label"><b>Name *</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="managedDeviceObj.name"
                class="width100"
                [(ngModel)]="managedDeviceObj.name"
                #nameInput="ngModel"
                required
              />
              <div
                class="error"
                *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)"
              >
                <mat-error *ngIf="nameInput?.errors?.required"> Required</mat-error>
                <mat-error *ngIf="nameInput.errors.regex && !nameInput.errors.required"
                  >Name should not contain '?,%,/' special characters</mat-error
                >
              </div>
            </div>
            <div class="location-fields">
              <div class="label"><b>Location</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="managedDeviceObj.location"
                [(ngModel)]="managedDeviceObj.location"
                class="width100"
              />
            </div>
            <div class="latitude-fields">
              <div class="latitude-field">
                <div class="label"><b>Latitude</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="managedDeviceObj.latitude"
                  [(ngModel)]="managedDeviceObj.latitude"
                  class="width40"
                  #latitudeInput="ngModel"
                  [pattern]="latitudeIPRegex"
                />
                <div
                  class="error"
                  *ngIf="latitudeInput.invalid && (latitudeInput.dirty || latitudeInput.touched)"
                >
                  <mat-error *ngIf="latitudeInput.errors?.pattern"
                    >Invalid Latitude value</mat-error
                  >
                </div>
              </div>
              <div class="longitude-field">
                <div class="label"><b>Longitude</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="managedDeviceObj.longitude"
                  [(ngModel)]="managedDeviceObj.longitude"
                  class="width40"
                  #longitudeInput="ngModel"
                  [pattern]="longitudeIPRegex"
                />
                <div
                  class="error"
                  *ngIf="longitudeInput.invalid && (longitudeInput.dirty || longitudeInput.touched)"
                >
                  <mat-error *ngIf="longitudeInput.errors?.pattern"
                    >Invalid Longitude value</mat-error
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="vendor-section-data">
            <div class="vendor-field-data">
              <div class="label"><b>Vendor</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="managedDeviceObj.vendor"
                class="width100"
                [(ngModel)]="managedDeviceObj.vendor"
                #vendorInput="ngModel"
                [disabled]="true"
              />
            </div>
            <div class="vendor-field-data">
              <div class="label"><b>Model</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="managedDeviceObj.model"
                class="width100"
                [(ngModel)]="managedDeviceObj.model"
                #modelInput="ngModel"
                [disabled]="true"
              />
            </div>
            <div class="vendor-field-data">
              <div class="label"><b>Version</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="managedDeviceObj.version"
                class="width100"
                [(ngModel)]="managedDeviceObj.version"
                #versionInput="ngModel"
                [disabled]="true"
              />
            </div>
          </div>
        </div>
        <div class="section-container" *ngIf="esamAttributes.isEsam">
          <div class="section-data">
            <div class="jmep-status-frequency">
              <div class="jmep-status">
                <div class="label"><b>JMEP Status Frequency</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  name="esamAttributes.jmepStatusFrequency"
                  class="width40"
                  [(ngModel)]="esamAttributes.jmepStatusFrequency"
                  #jmepStatusFrequencyInput="ngModel"
                  min="10"
                  max="3600"
                  required
                  placeholder="10-3600"
                />
                <b class="sub-label">sec</b>
                <div
                  class="error"
                  *ngIf="
                    jmepStatusFrequencyInput.invalid &&
                    (jmepStatusFrequencyInput.dirty || jmepStatusFrequencyInput.touched)
                  "
                >
                  <mat-error
                    *ngIf="
                      esamAttributes.jmepStatusFrequency >= 0 &&
                      !jmepStatusFrequencyInput?.errors?.required
                    "
                    >JMEP Status Frequency should be between 10-3600 seconds</mat-error
                  >
                  <mat-error *ngIf="jmepStatusFrequencyInput?.errors?.required">required</mat-error>
                </div>
              </div>
            </div>
            <div class="pm-retrieval">
              <div class="type-section-label width60">
                <mat-checkbox
                  (change)="onChecked('pmRetrieval', $event)"
                  [checked]="esamAttributes.isPMRetrievalChecked"
                  [disabled]="true"
                  color="primary"
                >
                  <b class="second-label">Turn On Traffic/PM Retrieval</b></mat-checkbox
                >
              </div>
              <div class="pm-interval width40" *ngIf="esamAttributes.isPMRetrievalChecked">
                <div class="label"><b>PM Interval</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="esamAttributes.pmInterval"
                  [(ngModel)]="esamAttributes.pmInterval"
                  #pmIntervalInput="ngModel"
                  class="width40"
                  [disabled]="true"
                  required
                />
                <b class="sub-label">minutes</b>
                <div
                  class="error"
                  *ngIf="
                    pmIntervalInput.invalid && (pmIntervalInput.dirty || pmIntervalInput.touched)
                  "
                >
                  <mat-error *ngIf="pmIntervalInput?.errors?.required">required</mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="esam-section-container"
          *ngIf="esamAttributes.isEsam && esamAttributes.isNewConfigSupported"
          [ngClass]="esamAttributes.enableJmepRelease ? 'enabledCheckBox' : 'disabledCheckBox'"
        >
          <div class="width40">
            <mat-checkbox
              (change)="onChecked('jmepReleaseDelay', $event)"
              [checked]="esamAttributes.enableJmepRelease"
              [(ngModel)]="esamAttributes.enableJmepRelease"
              color="primary"
            >
              <b class="second-label">Enable JMEP Release</b>
              <i
                class="icon mdi mdi-help-circle"
                title='JMEPs can only be managed by one ESAM at a time. When the "JMEP Release" feature is enabled the ESAM will stop managing its JMEPs when the Fusion application on the Fusion controller is non-responsive for the amount of time specified by JMEP Release Delay.  The unmanaged JMEPs can be discovered/managed by another ESAM'
              >
              </i>
            </mat-checkbox>
          </div>
          <div class="jmep-release" *ngIf="esamAttributes.enableJmepRelease">
            <div class="label"><b>JMEP Release Delay</b></div>
            <input
              matInput
              autocomplete="off"
              type="text"
              name="esamAttributes.jmepReleaseDelay"
              [(ngModel)]="esamAttributes.jmepReleaseDelay"
              #jmepReleasedelayInput="ngModel"
              (ngModelChange)="onChangeJmepReleaseDelay(esamAttributes.jmepReleaseDelay)"
              class="width40"
              placeholder="HH:MM"
              required
            />
            <b class="sub-label">(hour:min)</b>
            <div
              class="error"
              *ngIf="
                jmepReleasedelayInput.invalid &&
                (jmepReleasedelayInput.dirty || jmepReleasedelayInput.touched)
              "
            >
              <mat-error *ngIf="jmepReleasedelayInput?.errors?.required">required</mat-error>
            </div>
            <mat-error *ngIf="!jmepReleasedelayInput?.errors?.required && invalidTimeMsg">{{
              invalidTimeMsg
            }}</mat-error>
          </div>
        </div>
        <div
          class="esam-section-container"
          *ngIf="
            isGeoRedundancyEnabled && esamAttributes.isEsam && esamAttributes.isNewConfigSupported
          "
          [ngClass]="
            esamAttributes.isControllerSwitchoverChecked ? 'enabledCheckBox' : 'disabledCheckBox'
          "
        >
          <div class="width40">
            <mat-checkbox
              (change)="onChecked('controllerSwitchover', $event)"
              [checked]="esamAttributes.isControllerSwitchoverChecked"
              color="primary"
            >
              <b class="second-label">Enable Controller Switchover</b>
            </mat-checkbox>
          </div>
          <div class="switchover-delay" *ngIf="esamAttributes.isControllerSwitchoverChecked">
            <div class="label"><b>Switchover Delay</b></div>
            <input
              matInput
              autocomplete="off"
              type="number"
              name="esamAttributes.switchoverDelay"
              [(ngModel)]="esamAttributes.switchoverDelay"
              class="width40"
              [(ngModel)]="esamAttributes.switchoverDelay"
              #switchoverDelayInput="ngModel"
              min="0"
              max="9999"
              required
            />
            <b class="sub-label">min</b>
            <div
              class="error"
              *ngIf="
                switchoverDelayInput.invalid &&
                (switchoverDelayInput.dirty || switchoverDelayInput.touched)
              "
            >
              <mat-error *ngIf="switchoverDelayInput?.errors?.required"
                >Switchover Delay is required</mat-error
              >
              <mat-error
                *ngIf="
                  esamAttributes.switchoverDelay >= 0 && !switchoverDelayInput?.errors?.required
                "
                >Switchover Delay should be between 10-9999 minutes</mat-error
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div *ngIf="!isLoading">
    <div class="btn-group add-device">
      <button
        mat-flat-button
        class="save-btn"
        [disabled]="esamAttributes.isEsam ? !form.valid || invalidTimeMsg : !form.valid"
        (click)="saveDevice()"
      >
        SAVE
      </button>
      <button mat-button class="save-btn cancel" mat-dialog-close>CANCEL</button>
    </div>
  </div>
</div>
